import { useEffect, useState } from 'react';

/**
 * Shared mobile breakpoint helper.
 *
 * Matches Joy UI's `md` breakpoint (≤959.95px) — the same cutoff used by
 * `ResponsiveTable` and the CRM board's list/board switch — so JS-driven
 * layout branches stay in sync with the `sx={{ xs, md }}` breakpoints used
 * elsewhere in the app.
 */
export const MOBILE_QUERY = '(max-width: 959.95px)';

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
